<template>
  <div class="downloads-container">
    <div class="downloads-header">
      <h1>资料下载</h1>
      <p>获取最新的产品资料、技术文档和解决方案</p>
    </div>
    
    <!-- 资料分类组件 -->
    <div class="downloads-category">
      <h3>资料分类</h3>
      <div class="category-buttons">
        <button 
          v-for="category in categories" 
          :key="category"
          :class="{ active: selectedCategory === category }"
          @click="selectCategory(category)"
        >
          {{ category }}
        </button>
        <button 
          :class="{ active: selectedCategory === '全部' }"
          @click="selectCategory('全部')"
        >
          全部
        </button>
      </div>
    </div>
    
    <!-- 资料列表组件 -->
    <div class="downloads-list">
      <div 
        v-for="item in filteredDownloads" 
        :key="item.id"
        class="download-item"
      >
        <div class="item-info">
          <h4>{{ item.title }}</h4>
          <p class="item-description">{{ item.description }}</p>
          <div class="item-meta">
            <span class="item-category">{{ item.category }}</span>
            <span class="item-format">{{ item.format }}</span>
            <span class="item-size">{{ item.size }}</span>
          </div>
        </div>
        <div class="item-actions">
          <button class="btn-download" @click="downloadFile(item)">
            <span class="btn-icon">📥</span>
            下载
          </button>
          <button class="btn-preview" @click="previewFile(item)">
            <span class="btn-icon">👁️</span>
            预览
          </button>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-if="filteredDownloads.length === 0" class="empty-state">
        <p>暂无相关资料</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Downloads',
  data() {
    return {
      downloads: [],
      categories: [],
      selectedCategory: '全部',
      loading: false
    }
  },
  computed: {
    filteredDownloads() {
      if (this.selectedCategory === '全部') {
        return this.downloads
      }
      return this.downloads.filter(item => item.category === this.selectedCategory)
    }
  },
  mounted() {
    this.fetchDownloads()
  },
  methods: {
    async fetchDownloads() {
      this.loading = true
      try {
        // 预留接口对接位置
        // 实际项目中应使用：
        // const response = await this.$api.downloadsApi.getDownloads()
        // this.downloads = response.data
        
        // 目前使用 mock 数据
        const { mockApi } = require('../api/mock')
        const response = await mockApi.getDownloads()
        this.downloads = response.data
        
        // 提取所有分类
        const categorySet = new Set()
        this.downloads.forEach(item => {
          categorySet.add(item.category)
        })
        this.categories = Array.from(categorySet)
      } catch (error) {
        console.error('获取下载资料失败:', error)
      } finally {
        this.loading = false
      }
    },
    selectCategory(category) {
      this.selectedCategory = category
    },
    downloadFile(item) {
      // 实际项目中应使用：
      // window.open(item.fileUrl, '_blank')
      
      // 目前使用模拟下载
      console.log('下载文件:', item.title)
      alert(`开始下载: ${item.title}`)
    },
    previewFile(item) {
      // 预留文件预览功能
      console.log('预览文件:', item.title)
      alert(`预览功能开发中: ${item.title}`)
    }
  }
}
</script>

<style scoped>
.downloads-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.downloads-header {
  text-align: center;
  margin-bottom: 40px;
}

.downloads-header h1 {
  font-size: 36px;
  margin-bottom: 10px;
  color: #333;
}

.downloads-header p {
  font-size: 18px;
  color: #666;
}

.downloads-category {
  margin-bottom: 30px;
}

.downloads-category h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.category-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-buttons button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.category-buttons button:hover {
  border-color: #007bff;
  color: #007bff;
}

.category-buttons button.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.downloads-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.download-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.download-item:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.item-info {
  flex: 1;
}

.item-info h4 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.item-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.5;
}

.item-meta {
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #999;
}

.item-actions {
  display: flex;
  gap: 10px;
}

.btn-download, .btn-preview {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download {
  background-color: #007bff;
  color: #fff;
}

.btn-download:hover {
  background-color: #0056b3;
}

.btn-preview {
  background-color: #6c757d;
  color: #fff;
}

.btn-preview:hover {
  background-color: #5a6268;
}

.btn-icon {
  font-size: 16px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #eee;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .downloads-container {
    padding: 20px 15px;
  }
  
  .downloads-header h1 {
    font-size: 28px;
  }
  
  .download-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .item-actions {
    align-self: flex-end;
  }
  
  .category-buttons {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .downloads-header h1 {
    font-size: 24px;
  }
  
  .downloads-header p {
    font-size: 16px;
  }
  
  .item-meta {
    flex-direction: column;
    gap: 5px;
  }
  
  .item-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .btn-download, .btn-preview {
    flex: 1;
    justify-content: center;
  }
}
</style>